import React from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import "../styles/HomePageStyles/timing.css";
import img1 from "../assets/Timing/bigimg2.webp";
import mobileApp from "../assets/Timing/MobileApp.png";
import ap1 from "../assets/Timing/Appstore.jpg";
import ap2 from "../assets/Timing/playstore.jpg";
import { Link } from "react-router-dom";

const Timing = ({
  unlock_title,
  unlock_description,
  unlock_left_image,
  unlock_right_image,
  unlock_app_store_link,
  unlock_play_store_link,
}) => {
  Aos.init({
    offset: 0,
    duration: 1000,
    once: true,
    easing: "ease-out-cubic",
    disable: "phone",
  });

  const appStoreLink =
    "https://apps.apple.com/in/app/rollz-ice-cream/id6475342267";

  const playStoreLink =
    "https://play.google.com/store/apps/details?id=com.rollz.franchise";
  return (
    <div className="timing_container_wrapper">
      <div className="timing_container_top">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1000 100"
          fill="#ffecf0"
        >
          <path d="M0 0v60c9 0 18-3 25-10 13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s37 13 50 0c14-14 37-14 50 0 7 7 16 10 25 10V0H0Z"></path>
        </svg>
      </div>

      <div className="contianer_wrapper timing_container">
        <div className="timing_wrapper">
          <div className="timing_img" data-aos="zoom-out">
            <div className="timing_img_container">
              <img
                src={unlock_left_image || img1}
                alt=""
                className="img-fluid"
              />
            </div>
          </div>

          <div className="timing_details" data-aos="zoom-out">
            <div className="timing_heading">
              {unlock_title && unlock_title !== "-" ? (
                <h2>{unlock_title}</h2>
              ) : (
                <h2>Unlock Exclusive Rewards with Our Loyalty App!</h2>
              )}

              {unlock_description && unlock_description !== "-" ? (
                <p className="mb-3">{unlock_description}</p>
              ) : (
                <p className="mb-3">
                  Get closer to your next reward with every transaction. Enjoy
                  special promotions and deals available only to app users.
                  Tailored just for you, based on your Rollz history and
                  preferences.
                </p>
              )}

              {/* <h5>Download the app now <span>&gt,&gt</span></h5> */}
              <h5>
                Download the app now <span>&gt;&gt;</span>
              </h5>
            </div>

            {/* <div className="timings_container">
              <table className="timings">
                <tbody className="timing-wrapper">
                  <tr className="time">
                    <td>9am to 5pm</td>
                    <td className="timing-dash"> ------------- </td>
                    <td>Monday</td>
                  </tr>
                  <tr className="time">
                    <td>9am to 5pm</td>
                    <td className="timing-dash"> ------------- </td>
                    <td>Tuesday</td>
                  </tr>
                  <tr className="time">
                    <td>9am to 5pm</td>
                    <td className="timing-dash"> ------------- </td>
                    <td>Wednesday</td>
                  </tr>
                  <tr className="time">
                    <td>9am to 5pm</td>
                    <td className="timing-dash"> ------------- </td>
                    <td>Thursday</td>
                  </tr>
                  <tr className="time">
                    <td>9am to 5pm</td>
                    <td className="timing-dash"> ------------- </td>
                    <td>Friday</td>
                  </tr>
                  <tr className="time">
                    <td>9am to 5pm</td>
                    <td className="timing-dash"> ------------- </td>
                    <td>Saturday</td>
                  </tr>
                  <tr className="time">
                    <td>9am to 5pm</td>
                    <td className="timing-dash"> ------------- </td>
                    <td>Sunday</td>
                  </tr>
                </tbody>
              </table>
            </div> */}
          </div>

          <div className="timing_right_container">
            <div className="timing_apps_container">
              <div className="img1_container" data-aos="zoom-out">
                <Link
                  to={
                    unlock_app_store_link !== "" &&
                    unlock_app_store_link !== "-"
                      ? unlock_app_store_link
                      : appStoreLink
                  }
                  target="_blank"
                >
                  <img src={ap1} alt="" className="img-fluid" />
                </Link>

                <Link
                  to={
                    unlock_play_store_link !== "" &&
                    unlock_play_store_link !== "-"
                      ? unlock_play_store_link
                      : playStoreLink
                  }
                  target="_blank"
                >
                  <img src={ap2} alt="" className="img-fluid" />
                </Link>
              </div>
              <div className="img2_container" data-aos="zoom-out">
                <img
                  src={unlock_right_image || mobileApp}
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Timing;
